import React from 'react';
import styles from './GrowingLoader.module.css'

function GrowingLoader(props) {
    return (
        <div>
            <div >
                <div className={styles.loader3}></div>
            </div>
        </div>
    );
}

export default GrowingLoader;